import { Link } from "react-router-dom";

const quickLinks = [
  { to: "/leads", label: "线索广场" },
  { to: "/bounty", label: "悬赏榜" },
  { to: "/submit", label: "提供线索" },
  { to: "/faq", label: "常见问题" },
  { to: "/about", label: "关于我们" },
];

const hotTags = [
  "消费维权",
  "环境安全",
  "网络乱象",
  "财经线索",
  "职场内幕",
  "民生关注",
  "教育观察",
  "行业黑幕",
];

export default function Footer() {
  const year = new Date().getFullYear();

  return (
    <footer className="mt-16 bg-secondary-950 text-background-100 md:mt-24">
      <div className="mx-auto w-full max-w-7xl px-4 py-12 md:px-8 md:py-16">
        <div className="grid grid-cols-1 gap-10 md:grid-cols-2 lg:grid-cols-4">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2">
              <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500 font-heading text-base font-bold text-background-50">
                爆
              </span>
              <span className="font-heading text-lg font-bold text-background-50">
                爆料<span className="text-accent-400">51</span>
              </span>
            </div>
            <p className="mt-4 text-sm leading-relaxed text-background-300">
              面向全网开放的公众线索征集平台，用真实、可核实的信息推动议题被看见，让真相浮出水面。
            </p>
            <p className="mt-4 flex items-center gap-2 text-sm text-background-200">
              <i className="ri-mail-line text-accent-400" />
              tips@baoliao51.com
            </p>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">快速导航</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm">
              {quickLinks.map((link) => (
                <li key={link.to}>
                  <Link to={link.to} className="text-background-300 transition-colors hover:text-accent-300">
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">线索分类</h4>
            <ul className="mt-4 flex flex-wrap gap-2">
              {hotTags.map((tag) => (
                <li key={tag}>
                  <Link
                    to="/leads"
                    className="inline-block rounded-md border border-background-700/60 px-2.5 py-1 text-xs text-background-300 transition-colors hover:border-accent-500 hover:text-accent-300"
                  >
                    {tag}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-base font-bold text-background-50">征集原则</h4>
            <ul className="mt-4 flex flex-col gap-3 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line mt-0.5 text-accent-400" />
                来源信息脱敏与权限分级
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-scales-3-line mt-0.5 text-accent-400" />
                只采纳真实、可核实的线索
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-forbid-2-line mt-0.5 text-accent-400" />
                拒绝隐私侵害与恶意攻击
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-12 flex flex-col gap-3 border-t border-background-800/60 pt-6 text-xs text-background-400 sm:flex-row sm:items-center sm:justify-between">
          <p>© {year} 爆料51 · 线索征集平台. 保留所有权利.</p>
          <p className="leading-relaxed">
            本站为信息征集与展示平台，所涉线索均须真实、合法。请勿提交侵犯他人隐私或违反法律法规的内容。
          </p>
        </div>
      </div>
    </footer>
  );
}